import React from 'react';
import {string} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {PrizePublishStatus} from 'utils/DBUtils';

const PrizeStatus = ({prizeStatus}) => prizeStatus in PrizePublishStatus && (
  <div className={`prize-status ${prizeStatus}`}>
    <FormattedMessage id={`prizeList.column.status.enum.${prizeStatus}`} />
  </div>
);

PrizeStatus.propTypes = {
  publishStatus: string
};

export default PrizeStatus;



// WEBPACK FOOTER //
// ./public/components/prizes/PrizeStatus.jsx